import { Nilable } from "@shared/utils";
import { MensajeProcesador } from "../MensajeProcesador";

export class ErrorServidorProcesador implements MensajeProcesador {
    puedeProcesar(mensaje: string): boolean {
        return mensaje.includes("url") && mensaje.includes("500");
    }

    procesar(_mensaje: string): Nilable<string> {
        return "Hubo un error en el servidor";
    }
}
